#import '../queries/BarMitzvahDetails.graphql'
mutation AddOrUpdateBarMitzvah(
  $userData: UserInput!
  $date: String!
  $hidden: Boolean!
  $kippahReminder: Boolean!
  $practiceTracking: Boolean!
  $torahMelody: ID!
  $haftarahMelody: ID!
  $sentenceGroupMelody: ID!
  $pronunciation: ID!
  $update: Boolean!
) {
  addOrUpdateBarMitzvah(
    userData: $userData
    date: $date
    hidden: $hidden
    kippahReminder: $kippahReminder
    practiceTracking: $practiceTracking
    torahMelody: $torahMelody
    haftarahMelody: $haftarahMelody
    sentenceGroupMelody: $sentenceGroupMelody
    pronunciation: $pronunciation
    update: $update
  ) {
    ok
    errors
    barMitzvah {
      ...barMitzvahDetails
    }
  }
}
